import { TeammateFormFields, TeammateRole } from '@/types/teammates';

export const initalTeammateForm: TeammateFormFields = {
  uuid: '',
  firstName: '',
  lastName: '',
  email: '',
  role: TeammateRole.ADVISOR,
  title: '',
  cellPhoneNumber: '',
  businessPhoneNumber: '',
  companyId: '',
  branchOfficeName: '',
  bio: '',
  members: [],
  avatarUrl: '',
  avatarDisplayName: '',
  alias: '',
};
